import React from 'react'
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

interface Props {
  startTime: number
}

interface State {
  timeRemaining: number
}

class Countdown extends React.Component<Props, State> {

  private timer: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      timeRemaining: props.startTime
    };
  } 
  
  decrementTime = () => {
    if (this.state.timeRemaining > 0) {
      this.setState({
        timeRemaining: this.state.timeRemaining - 1
      });
    } else {
      clearInterval(this.timer!);
    }
  };  

  componentDidMount() {
    this.timer = setInterval(() => {
      this.decrementTime();
    }, 1000);
  }  

  componentWillUnmount(): void {
    clearInterval(this.timer)
  } 

  render() {

    return (  
      <Box my={3}>
        <Typography variant="h3" color="primary">{this.state.timeRemaining}</Typography>
      </Box>
    );
  }

  }

export default Countdown;  